import * as React from 'react';
import { registerDecorator } from '@avensia/excite-contentful/Document';
import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { QuoteIcon } from 'nordicnest/shared/icons';
import { theme } from 'nordicnest/shared/theme';

registerDecorator<Excite.Contentful.QuoteApiModel>(
  'blockquote',
  styled(({ children }) => (
    <Blockquote>
      <Icon />
      {children}
    </Blockquote>
  )),
);

const Icon = styled(
  QuoteIcon,
  createMinLargeViewportDecorator({
    marginRight: t => t.sharedSpacing.m,
  }),
  {
    flexShrink: 0,
    marginRight: t => t.sharedSpacing.s,
  },
);

const Blockquote = styled.blockquote(
  createMinLargeViewportDecorator({
    fontSize: 26,
    lineHeight: '36px',
    marginLeft: `calc(-39px + -${theme.sharedSpacing.m}px)`,
  }),
  {
    position: 'relative',
    display: 'flex',
    fontSize: t => t.sharedFontSize.m,
    color: t => t.secondary.color,
    margin: {
      bottom: t => t.sharedSpacing.xxl,
    },
  },
);
